import InfoRow from '../InfoRow'
import OrderPill from '@/features/orders/components/OrderListItem/OrderPill'
import { paymentTypeIconMap } from '@/features/orders/components/OrderListItem/utils/iconMaps'
import { PaymentType } from '@/features/orders/constants/app'
import { Order } from '@/features/orders/types/app'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface PaymentStatusRowProps {
    paymentType?: Order['paymentType']
}

const PaymentStatusRow: FC<PaymentStatusRowProps> = ({ paymentType }) => {
    const { t } = useTranslation()

    const paymentTypeIcon = paymentType ? paymentTypeIconMap[paymentType.type] : null

    if (!paymentTypeIcon) return null

    return (
        <InfoRow
            Icon={paymentTypeIcon}
            content={
                paymentType?.type === PaymentType.Online ? (
                    <OrderPill>{t('order.paymentStatus.paid')}</OrderPill>
                ) : null
            }
        />
    )
}

export default PaymentStatusRow
